import CalendarEventContent from './component';

export default CalendarEventContent;
